import { getColorByDisplayId } from '@utils/map/map.utils';
import { isCoordinates3D, toLonLatArray } from '@utils/validation/coordinates.utils';
import { Feature, Position } from 'geojson';

import { DroneTrajectories } from '@/types/data/data.types';
import { FeatureTypeEnum } from '@/types/map.types';

function toStatisticPointFeatures(notification: DroneTrajectories): Feature[] {
  const trajectoryColor = getColorByDisplayId(notification.displayId ?? notification.identifier);
  const features: Feature[] = [];

  notification.trajectory.forEach((point, index) => {
    const pos = toLonLatArray(point);
    if (pos) {
      features.push({
        type: 'Feature',
        id: `${FeatureTypeEnum.STATISTIC_POINT}-${notification.id}_${index}`,
        properties: {
          id: `${notification.id}_${index}`,
          featureType: FeatureTypeEnum.STATISTIC_POINT,
          value: {
            displayId: notification.displayId,
            id: notification.id,
            reliability: notification.reliability,
            startTime: notification.startTime,
            endTime: notification.endTime,
            maxTransmittedAgl: notification.maxTransmittedAgl,
            maxComputedAgl: notification.maxComputedAgl,
            maxTransmittedAsl: notification.maxTransmittedAsl,
            maxComputedAsl: notification.maxComputedAsl,
            trackIds: notification.trackIds,
            worstAlertLevel: notification.worstAlertLevel,
            altitude: isCoordinates3D(point) ? point.altitude : null,
          },
          trajectoryColor,
          maxTransmittedAgl: notification.maxTransmittedAgl,
          maxComputedAgl: notification.maxComputedAgl,
          maxTransmittedAsl: notification.maxTransmittedAsl,
          maxComputedAsl: notification.maxComputedAsl,
          worstAlertLevel: notification.worstAlertLevel,
        },
        geometry: {
          type: 'Point',
          coordinates: pos,
        },
      } as Feature);
    }
  });

  return features;
}

function toStatisticTrajectoryFeature(notification: DroneTrajectories): Feature {
  const trajectoryColor = getColorByDisplayId(notification.displayId ?? notification.identifier);
  const coordinates: Position[] = [];
  for (const item of notification.trajectory) {
    const pos = toLonLatArray(item);
    if (pos) {
      coordinates.push(pos);
    }
  }

  return {
    type: 'Feature',
    id: `${FeatureTypeEnum.STATISTIC_TRAJECTORY}-${notification.id}`,
    properties: {
      id: notification.id,
      featureType: FeatureTypeEnum.STATISTIC_TRAJECTORY,
      maxTransmittedAgl: notification.maxTransmittedAgl,
      maxComputedAgl: notification.maxComputedAgl,
      maxTransmittedAsl: notification.maxTransmittedAsl,
      maxComputedAsl: notification.maxComputedAsl,
      worstAlertLevel: notification.worstAlertLevel,
      trajectoryColor,
    },
    geometry: {
      type: 'LineString',
      coordinates,
    },
  };
}

export function toStatisticFeatures(notifications: DroneTrajectories[]): Feature[] {
  const trajectoryFeatures = notifications.map(toStatisticTrajectoryFeature);
  return [...notifications.flatMap(toStatisticPointFeatures), ...trajectoryFeatures];
}
